<div class="content">
  <form #dienstleistungsModuleForm="ngForm" data-qa="dienstleistungs-module-form">

    <header>
      <div>
      </div>

      <div class="buttons">

        <button matButton="outlined"
          data-qa="cancel-dienstleistungs-module-button"
          (click)="westnetzSidenavService.closeRightnav()">
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Schließen
        </button>

        <button matButton="filled"
          [disabled]="!dienstleistungsModuleForm.form.valid"
          data-qa="submit-dienstleistungs-module-button"
          (click)="save()">
          <mat-icon>save</mat-icon>
          Speichern
        </button>

      </div>
    </header>

    <div class="detail-main">

      <fieldset>
        <legend>Dienstleistungsmodule editieren</legend>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Interne programmatisch Bezeichnung</mat-label>
          <input matInput
            maxlength="100"
            [(ngModel)]="module.dienstleistungsmodule"
            id="dienstleistungsmodule_{{module.id}}"
            name="dienstleistungsmodule_{{module.id}}"
            data-qa="dienstleistungsmodule"
            disabled="disabled"
            required/>
        </mat-form-field>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Titel</mat-label>
          <input matInput
            maxlength="100"
            #title="ngModel"
            [(ngModel)]="module.title"
            id="title_{{module.id}}"
            name="title_{{module.id}}"
            data-qa="title"
            required/>
          @if (title?.errors?.required) {
            <mat-error>
              Bitte tragen Sie den Title ein
            </mat-error>
          }
        </mat-form-field>

      </fieldset>
    </div>
  </form>
</div>
